import { noOp } from 'common/Constants';
import { DateTime } from 'luxon';
import { useCallback, useState } from 'react';
import { POST_TEXT } from '../consts';
import { PostProps } from '../types';
import { splitPromoCodeText } from '../utils';

export const usePost = (props: PostProps) => {
  const {
    autoFormatDate = true,
    comment: commentValue,
    clickCount = 0,
    createdAt,
    date,
    foodItemId: foodItemIdValue,
    id = '',
    isLikedByUser = false,
    isOnMenuPage,
    mediaUrl,
    numLikes = 0,
    onClickDelete = noOp,
    onClickLike,
    onClickMessage,
    onClickReport,
    onClickSave = noOp,
    onClickUnfollow,
    promoCodeId,
    promoCodeString,
    shefId,
    shefImageUrl,
    shefMenuUrl,
    shefName,
    showHeaderMenu,
    showFooterMenu,
    showFooterLikes,
    showLikes,
    showViews,
    showVisits,
    viewCount = 0,
  } = props;

  const { comment: splitComment, promoText, promoCode } = splitPromoCodeText(commentValue);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [comment, setComment] = useState(splitComment.trim());
  const [foodItemId, setFoodItemId] = useState(foodItemIdValue);

  return {
    ...props,
    bodyProps: {
      comment,
      onChangeComment: setComment,
      foodItemId,
      id,
      isEditMode,
      isOnMenuPage,
      mediaUrl,
      promoCode,
      promoCodeId,
      promoCodeString,
      promoText,
      shefId,
    },
    contentContainerProps: {
      isDeleteMode,
      noFooter: !showFooterMenu && !showFooterLikes && !showViews && !showVisits,
      noHeader: !(date ?? createdAt) && !showHeaderMenu && !showLikes && !shefImageUrl && !shefName,
      noImage: !mediaUrl,
    },
    imageContainerProps: {
      isDeleteMode,
    },
    showFooter: !!showFooterMenu || !!showFooterLikes || !!showViews || !!showVisits,
    footerProps: {
      id,
      clickCount,
      numLikes,
      viewCount,
      isEditMode,
      isDeleteMode,
      onClickCancel: () => {
        setIsEditMode(false);
        setIsDeleteMode(false);
        setFoodItemId(foodItemIdValue);
      },
      onClickEditMenu: () => setIsEditMode(true),
      onClickDelete: () => {
        setIsEditMode(false);
        setIsDeleteMode(false);
        onClickDelete(id);
      },
      onClickDeleteMenu: () => {
        setIsEditMode(false);
        setIsDeleteMode(true);
      },
      onClickSave: useCallback(() => {
        setIsEditMode(false);
        onClickSave(id, {
          comment: promoText ? `${comment.trim()}\r\n\r\n${promoText}` : comment,
          foodItemId,
          mediaUrl: mediaUrl ?? undefined,
          promoCodeId: promoCodeId ?? undefined,
        });
      }, [comment, foodItemId, id, mediaUrl, onClickSave, promoCodeId, promoText]),
      showMenu: showFooterMenu,
      showLikes: showFooterLikes,
      showViews,
      showVisits,
    },
    hasImage: !!mediaUrl,
    headerProps: {
      date:
        autoFormatDate && (date || createdAt)
          ? DateTime.fromISO(date ?? createdAt ?? '').toFormat("MMMM d',' h:mm a")
          : date,
      numLikes,
      id,
      isLikedByUser,
      onClickLike,
      onClickMessage,
      onClickReport,
      onClickUnfollow,
      shefImageUrl,
      shefName,
      showLikes,
      showMenu: showHeaderMenu,
    },
    imageProps: {
      alt: POST_TEXT.IMAGE.ALT,
      src: mediaUrl ?? '',
      sourceHeight: 1000,
    },
    comment,
    numLikes,
    shefMenuUrl,
  };
};
